module.exports = __webpack_public_path__ + "static/img/redblack_en.36936c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/redblack_en.png
// module id = 2yQ0
// module chunks = 1